import React from "react";
import { Col, Row } from "reactstrap";

import { ManagerTabNavs } from "@/shared/components/tabNavs";
import SelectProgram from "./SelectProgram";

const ManagerTabSection = () => {
  return (
    <Row>
      <Col xs={12} md="auto" className="program-select">
        <SelectProgram showRefresh={false}  />
      </Col>
      <Col xs={12} md className="manager-tabnavs-wrap">
        <ManagerTabNavs />
      </Col>
    </Row>
  )
}

export default ManagerTabSection
